/**
 * 📦 V2 Stock API client
 * Rotas /api/v2/stock (gestão de estoque por produto físico)
 * Spec: docs/V2/07_REGRAS_NEGOCIO.md §6 (Estoque)
 */

import v2Api from './index';

export const stockV2API = {
  /**
   * Estoque atual do produto físico.
   * Retorna { current_quantity, reserved_quantity, ... }
   */
  getByPhysicalProduct: (physicalProductId) =>
    v2Api.get(`/stock/${physicalProductId}`),

  /**
   * Adiciona unidades ao estoque (entrada).
   * Body: { quantity, reason? }
   */
  add: (physicalProductId, data) =>
    v2Api.post(`/stock/${physicalProductId}/add`, data),

  /**
   * Ajuste manual do estoque (entrada ou saída).
   * Body: { quantity, reason }
   * quantity pode ser negativo (decremento).
   */
  adjust: (physicalProductId, data) =>
    v2Api.post(`/stock/${physicalProductId}/adjust`, data),

  /** Lista movimentações de estoque (auditoria). */
  movements: (physicalProductId, params = {}) =>
    v2Api.get(`/stock/${physicalProductId}/movements`, { params }),
};

export default stockV2API;
